module.exports = __webpack_public_path__ + "static/media/auto-fc.b308e738.svg";